// ≤1024px nav drawer (sections/gt-faceplate-header.liquid): the <details> drives
// open/close; this adds scroll lock, backdrop/× close, Esc, and focus handling.
(() => {
  const details = document.querySelector('.fs-navdetails');
  if (!details) return;
  const summary = details.querySelector('summary');
  const mq = window.matchMedia('(max-width: 1024px)');

  const sync = () => {
    document.documentElement.classList.toggle('fs-drawer-open', details.open && mq.matches);
  };

  const close = () => {
    details.open = false;
    summary.focus();
  };

  details.addEventListener('toggle', () => {
    sync();
    if (details.open && mq.matches) details.querySelector('.fs-drawer-close')?.focus();
  });
  mq.addEventListener('change', sync);

  details.addEventListener('click', (event) => {
    if (event.target.closest('[data-fs-drawer-close]')) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && details.open && mq.matches) close();
  });
})();
